module.exports = __webpack_public_path__ + "media/application/images/2018/star-green-54aa93599d4399d9cc1bcf2993c0f472.svg";